import { render } from "./configManage.vue?vue&type=template&id=1fcfd986&scoped=true"
import script from "./configManage.vue?vue&type=script&lang=js"
export * from "./configManage.vue?vue&type=script&lang=js"

import "./configManage.vue?vue&type=style&index=0&id=1fcfd986&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fcfd986"]])

export default __exports__